
import {salaryConfigEN} from "./salaryconfig/en";

export const WageEN = {
    ...salaryConfigEN
}